// src/hooks/useWorkouts.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { format, subDays } from "date-fns";
import {
    getMonthSummary,
    getDayWorkouts,
    createWorkout,
    updateWorkout,
    deleteWorkout,
    getLatestNearWorkout
} from "../api/workouts";

export function useMonthSummary(monthDate) {
    const ym = format(monthDate, "yyyy-MM");
    return useQuery({
        queryKey: ["monthSummary", ym],
        queryFn: () => getMonthSummary(monthDate),
    });
}

export function useDayWorkouts(dateObj) {
    const dateStr =
        typeof dateObj === "string" ? dateObj : format(dateObj, "yyyy-MM-dd");
    return useQuery({
        queryKey: ["dayWorkouts", dateStr],
        queryFn: () => getDayWorkouts(dateStr),
    });
}


export function useCreateWorkout() {
    return useMutation({
        mutationFn: (payload) => createWorkout(payload),
    });
}

export function useUpdateWorkout() {
    const qc = useQueryClient();
    return useMutation({
        // { id, data } 객체를 받아서 내부에서 분해해 호출
        mutationFn: ({ id, data }) => updateWorkout(id, data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ["dayWorkouts"] });
            qc.invalidateQueries({ queryKey: ["monthSummary"] });
        },
    });
}

export function useDayWorkoutsInvalidate() {
    const qc = useQueryClient();
    return async (dateStr) => {
        await qc.invalidateQueries({ queryKey: ["dayWorkouts", dateStr] });
        await qc.invalidateQueries({ queryKey: ["monthSummary"] });
    };
}

export function useDeleteWorkout() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => deleteWorkout(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ["dayWorkouts"] });
            qc.invalidateQueries({ queryKey: ["monthSummary"] });
        },
    });
}





export function useLatestWorkoutDay() {
    return useQuery({
        queryKey: ["latestWorkoutDay"],
        queryFn: async () => {
            try {
                const w = await getLatestNearWorkout(); // WorkoutOut 하나

                const dateStr = w.date;         // "YYYY-MM-DD"
                const date = new Date(w.date);  // Date 객체로

                // 예전 훅처럼 형태 맞춰서 반환
                return { date, dateStr, workouts: [w] };
            } catch (err) {
                // 운동 기록이 아예 없어서 백엔드가 404를 던진 경우
                const status =
                    err?.status ?? err?.response?.status ?? err?.statusCode;

                if (status === 404) {
                    const today = new Date();
                    const dateStr = format(today, "yyyy-MM-dd");
                    return { date: today, dateStr, workouts: [] };
                }

                // 그 외 에러는 react-query에게 에러로 넘겨주기
                throw err;
            }
        },
    });
}